import { Injectable } from '@angular/core';

@Injectable()
export class AuthorizationService {
  private permissions: string[] = [];

  // Almacena los permisos obtenidos del Access Token
  setPermissions(permissions: string[]): void {
    this.permissions = permissions;
  }

  // Comprueba si el usuario tiene un permiso específico
  hasPermission(permission: string): boolean {
    return this.permissions.includes(permission);
  }
}
